import { GlobalStyles, ThemeProvider, createTheme } from "@mui/material";
import { getTheme } from "Infrastructure/Themes/Themes";
import { type ReactNode, useMemo } from "react";

type Props = {
  children: ReactNode;
};

const HEADING_FONT_FAMILY = '"Fedra Sans Pro", "Arial", sans-serif';
export const PDF_BODY_FONT_FAMILY = '"Roboto", "Arial", sans-serif';

const HEADING_SELECTOR =
  ".pdf-root h1, .pdf-root h2, .pdf-root h3, .pdf-root .MuiTypography-h1, .pdf-root .MuiTypography-h2, .pdf-root .MuiTypography-h3";

export const PdfTemplateTheme = ({ children }: Props) => {
  const pdfTheme = useMemo(() => {
    const baseTheme = getTheme();

    return createTheme({
      ...baseTheme,
      typography: {
        ...baseTheme.typography,
        fontFamily: PDF_BODY_FONT_FAMILY,
        h1: { ...baseTheme.typography.h1, fontFamily: HEADING_FONT_FAMILY },
        h2: { ...baseTheme.typography.h2, fontFamily: HEADING_FONT_FAMILY },
        h3: { ...baseTheme.typography.h3, fontFamily: HEADING_FONT_FAMILY },
        subtitle1: { ...baseTheme.typography.subtitle1, fontFamily: PDF_BODY_FONT_FAMILY },
        subtitle2: { ...baseTheme.typography.subtitle2, fontFamily: PDF_BODY_FONT_FAMILY },
        body1: { ...baseTheme.typography.body1, fontFamily: PDF_BODY_FONT_FAMILY },
        body2: { ...baseTheme.typography.body2, fontFamily: PDF_BODY_FONT_FAMILY },
        caption: { ...baseTheme.typography.caption, fontFamily: PDF_BODY_FONT_FAMILY },
        overline: { ...baseTheme.typography.overline, fontFamily: PDF_BODY_FONT_FAMILY },
      },
      components: {
        ...baseTheme.components,
        MuiCssBaseline: {
          styleOverrides: `
                .pdf-root {
                font-family: ${PDF_BODY_FONT_FAMILY} !important;
                }
                ${HEADING_SELECTOR} {
                font-family: ${HEADING_FONT_FAMILY} !important;
                }
            `,
        },
      },
    });
  }, []);

  return (
    <ThemeProvider theme={pdfTheme}>
      <GlobalStyles
        styles={{
          ".pdf-root *": {
            fontFamily: `${PDF_BODY_FONT_FAMILY} !important`,
            // Without this the renderer drops background fills, which is what marks the selected answers.
            WebkitPrintColorAdjust: "exact",
            printColorAdjust: "exact",
          },
          [HEADING_SELECTOR]: {
            fontFamily: `${HEADING_FONT_FAMILY} !important`,
          },
        }}
      />
      <div className="pdf-root">{children}</div>
    </ThemeProvider>
  );
};
